import { NadoutongLogo } from './logos/index.tsx';

/**
 * Brand wordmark — the Nadoutong radial-arrow mark followed by the
 * Chinese product name `哪都通`. Rendered by `Header` at the top of
 * every page and by `Footer`. The product name stays verbatim in
 * Chinese regardless of locale — it's a brand name, not a
 * translatable descriptor.
 */
interface Props {
  readonly className?: string;
}

export function Wordmark({ className }: Props): JSX.Element {
  return (
    <div className={['flex items-center gap-3', className ?? ''].join(' ')}>
      <NadoutongLogo className="h-9 w-9 shrink-0" />
      <span className="font-display text-[24px] font-semibold leading-none text-ink">
        哪都通
      </span>
    </div>
  );
}
